export const GET_DATA_CONTROL = 'GET_DATA_CONTROL'
export const GET_DATA_CONTROL_CATEGORIAARCHIVO = 'GET_DATA_CONTROL_CATEGORIAARCHIVO'
export const GET_DATA_CONTROL_CLONE = 'GET_DATA_CONTROL_CLONE'
export const GET_INFO_DATA_CONTROL_EDITED = 'GET_INFO_DATA_CONTROL_EDITED'
export const LOADING_DATA_CONTROL = 'LOADING_DATA_CONTROL'